import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class TipoRespostaService {

  url: string = environment.BASE_URL;

  private tipoResposta = new Subject<any>();
  tipoResposta$ = this.tipoResposta.asObservable();

  constructor(private http: HttpClient) {}

  getTipoResposta(searchParams): Observable<any> {
    const params = this.setParams(searchParams);
    return this.http.get(`${this.url}/tiposResposta`, { params: params })
      .map(data => {
        const body = data;
        this.tipoResposta.next(body);
        return body;
      });
  }

  getSituacaoTipoResposta(searchParams): Observable<any> {
    const params = this.setParams(searchParams);
    return this.http.get(`${this.url}/tiposResposta/listaTiposResposta`, { params: params })
      .map(data => {
        const body = data;
        this.tipoResposta.next(body);
        return body;
      });
  }

  setParams(searchParams: any) {
    let params = new HttpParams();
    if (!searchParams) {
      return params;
    }
    if (searchParams.key && searchParams.value) {
      return params.set(searchParams.key, searchParams.value);
    }
    for (const key of Object.keys(searchParams)) {
      params = params.set(key, searchParams[key]);
    }
    return params;
  }

  obterTipoResposta(id: number): Observable<any> {
    return this.http.get(`${this.url}/tiposResposta/${id}`)
      .map(data => {
        const body = data;
        return body;
      });
  }

  editaTipoResposta(params: any, code): Observable<any> {
    const tipoResposta = params;
    const codigo = code;
    return this.http.put(`${this.url}/tiposResposta/${codigo}`, tipoResposta)
      .map(data => {
        const body = data;
        return body;
      });
  }

  incluirTipoResposta(obj) {
    return this.http.post(`${this.url}/tiposResposta/incluir`, obj);
  }

  consultaCodigo(codigo): Observable<any> {
    return this.http.get(`${this.url}/tiposResposta/${codigo}`);
  }

}
